import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ManageDevelopers = lazy(() =>
  import("@scenes/PermissionSettings/components/ManageDevelopers").then((module) => ({
    default: module.ManageDevelopers,
  }))
);

export const permissionSettingsCompanyUsersNRO: NavigationRoutingObject = {
  Component: ManageDevelopers,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("company-users", "Company Users"),
  pageNameForTracking: () => "Company Users",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("company-users-manage-users", "Manage Users")],
      description: t("previously-manage-users", 'Previously "Manage Users"'),
    },
    {
      keywords: [t("company-users-nro-additional-keyword-invite", "Invite Users")],
      description: t("company-users-nro-additional-description-invite", "Invite Users to Braze"),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/company_users/:appGroupId",
};
